import { jsx as _jsx } from "react/jsx-runtime";
const VARIANT_CLASSES = {
    luna: "bg-violet-500/20 text-violet-300 ring-1 ring-violet-500/40",
    ptolemy: "bg-indigo-500/20 text-indigo-300 ring-1 ring-indigo-500/40",
    vault: "bg-teal-500/20 text-teal-300 ring-1 ring-teal-500/40",
    orion: "bg-blue-500/20 text-blue-300 ring-1 ring-blue-500/40",
    argus: "bg-violet-500/20 text-violet-300 ring-1 ring-violet-500/40",
    compass: "bg-orange-500/20 text-orange-300 ring-1 ring-orange-500/40",
    aura: "bg-pink-500/20 text-pink-300 ring-1 ring-pink-500/40",
    talos: "bg-cyan-500/20 text-cyan-300 ring-1 ring-cyan-500/40",
    shield: "bg-lime-500/20 text-lime-300 ring-1 ring-lime-500/40",
    herald: "bg-yellow-500/20 text-yellow-300 ring-1 ring-yellow-500/40",
    "priority-high": "bg-rose-500/20 text-rose-300 ring-1 ring-rose-500/40",
    "priority-medium": "bg-amber-500/20 text-amber-300 ring-1 ring-amber-500/40",
    "priority-low": "bg-slate-600/40 text-slate-400 ring-1 ring-slate-600/40",
    orchestrated: "bg-violet-500/20 text-violet-300 ring-1 ring-violet-500/40",
    direct: "bg-sky-500/20 text-sky-300 ring-1 ring-sky-500/40",
    custom: "bg-emerald-500/20 text-emerald-300 ring-1 ring-emerald-500/40",
    success: "bg-emerald-500/20 text-emerald-300 ring-1 ring-emerald-500/40",
    warning: "bg-amber-500/20 text-amber-300 ring-1 ring-amber-500/40",
    error: "bg-rose-500/20 text-rose-300 ring-1 ring-rose-500/40",
    neutral: "bg-slate-700/40 text-slate-400 ring-1 ring-slate-600/40",
};
export function Badge({ variant = "neutral", children, className = "", size = "sm", }) {
    const sizeClass = size === "xs" ? "px-1.5 py-0.5 text-[10px] leading-4" :
        size === "sm" ? "px-2 py-0.5 text-xs" :
            "px-2.5 py-1 text-sm";
    return (_jsx("span", { className: `inline-flex items-center gap-1 rounded-full font-medium ${sizeClass} ${VARIANT_CLASSES[variant]} ${className}`, children: children }));
}
/** Map an agent_id string to the correct Badge variant. Falls back to neutral. */
export function agentVariant(agentId) {
    const id = agentId?.toLowerCase() ?? "";
    if (id.includes("luna"))
        return "luna";
    if (id.includes("ptolemy"))
        return "ptolemy";
    if (id.includes("vault"))
        return "vault";
    if (id.includes("orion"))
        return "orion";
    if (id.includes("argus"))
        return "argus";
    if (id.includes("compass"))
        return "compass";
    if (id.includes("aura"))
        return "aura";
    if (id.includes("talos"))
        return "talos";
    if (id.includes("shield"))
        return "shield";
    if (id.includes("herald"))
        return "herald";
    return "neutral";
}
